import type { AuthenticationContext } from '@connected/api-client/hooks/use-authentication';
import type { QueryClient } from '@tanstack/react-query';

import { ThemeManager } from '@connected/ui/components/theme-manager';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { Toaster } from 'sonner';

import { Confirmer } from '@/components/confirmer';
import { NotFound } from '@/components/not-found';

export const Route = createRootRouteWithContext<{
    queryClient: QueryClient;
} & AuthenticationContext<boolean | null>>()({
    component: RootComponent,
    notFoundComponent() {
        return <NotFound />;
    },
});

function RootComponent() {
    return (
        <>
            <ThemeManager />
            <Outlet />
            <Toaster />
            <Confirmer />
            {/* <TanStackRouterDevtools /> */}
            {/* <ReactQueryDevtools /> */}
        </>
    );
}
